<div class="summary-backdrop" (click)="closed.emit()">
  <section
    class="summary-card"
    [attr.data-kind]="summary().kind"
    role="dialog"
    aria-modal="true"
    aria-labelledby="summary-title"
    (click)="$event.stopPropagation()">
    <header class="card-header">
      <div class="title-row">
        <div class="title-main">
          <h2 id="summary-title">
            Riepilogo<span class="title-detail"> · {{ summary().title }}</span>
          </h2>
          <span class="card-tag">{{ summary().tag }}</span>
        </div>
        <button
          type="button"
          class="close-button"
          aria-label="Chiudi riepilogo"
          (click)="closed.emit()">
          <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
      </div>
      <p class="hint">Controlla i dati inseriti e conferma per procedere al pagamento.</p>
    </header>

    <div class="summary-scroll">
      <div class="details-card">
        <dl class="details-grid">
          <div>
            <dt>Nome</dt>
            <dd>{{ summary().nome }}</dd>
          </div>
          <div>
            <dt>Cognome</dt>
            <dd>{{ summary().cognome }}</dd>
          </div>
          <div>
            <dt>Codice fiscale</dt>
            <dd>{{ summary().codiceFiscale }}</dd>
          </div>
          @if (summary().extraDetailLabel && summary().extraDetailValue) {
            <div>
              <dt>{{ summary().extraDetailLabel }}</dt>
              <dd>{{ summary().extraDetailValue }}</dd>
            </div>
          }
          <div>
            <dt>{{ summary().amountLabel }}</dt>
            <dd>{{ summary().amountValue }}</dd>
          </div>
        </dl>

        @if (summary().note; as note) {
          <div class="note-row">
            <p class="note-label">Note</p>
            <p class="note-value">{{ note }}</p>
          </div>
        }
      </div>

      <div class="sum">
        @if (summary().unitCostLabel && summary().unitCostValue) {
          <div>
            <span>{{ summary().unitCostLabel }}</span>
            <span>{{ summary().unitCostValue }}</span>
          </div>
        }
        <div>
          <span>Costo</span>
          <span>{{ formatEuro(summary().baseCents) }}</span>
        </div>
        <div>
          <span class="fee-label">
            Costi di servizio
            <button
              type="button"
              class="info-button"
              [matTooltip]="serviceFeeHint"
              matTooltipPosition="above"
              [attr.aria-label]="serviceFeeHint">
              <i class="bi bi-info-circle" aria-hidden="true"></i>
            </button>
          </span>
          <span>{{ formatEuro(summary().feeCents) }}</span>
        </div>
        <div class="sum-total">
          <span>Totale</span>
          <span class="total-value">{{ formatEuro(summary().totalCents) }}</span>
        </div>
      </div>
    </div>

    <div class="summary-actions">
      <button type="button" class="pay" (click)="pay.emit()">
        Procedi al Pagamento
        <i class="bi bi-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
  </section>
</div>
